export const ROLE_LABEL = {
  admin: "Admin",
  manager: "Manager",
  op_manager: "Op Manager",
  hod: "HOD",
  facility_incharge: "Facility Incharge",
  outlet_incharge: "Outlet Incharge",
  outlet_staff: "Outlet Staff",
};

export const TYPE_LABEL = {
  maintenance: "Maintenance",
  product_issue: "Product Issue",
  structural_damage: "Structural Damage",
  new_installation: "New Installation",
  miscellaneous: "Miscellaneous",
  internal_job: "Internal Job",
};

export const PRIORITY_LABEL = {
  urgent: "Urgent",
  general: "General",
  routine: "Routine",
};

export const STATUS_LABEL = {
  open: "Open",
  in_progress: "In Progress",
  resolved: "Resolved",
};

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      day: "numeric", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
}

export function formatDuration(startIso, endIso) {
  if (!startIso || !endIso) return "—";
  try {
    const ms = new Date(endIso).getTime() - new Date(startIso).getTime();
    if (ms < 0) return "—";
    const mins = Math.floor(ms / 60000);
    if (mins < 60) return `${mins} min`;
    const hrs = Math.floor(mins / 60);
    const rem = mins % 60;
    if (hrs < 24) return rem ? `${hrs}h ${rem}m` : `${hrs}h`;
    const days = Math.floor(hrs / 24);
    const remH = hrs % 24;
    return remH ? `${days}d ${remH}h` : `${days}d`;
  } catch { return "—"; }
}

export function formatDay(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }); }
  catch { return iso; }
}

export function currency(n) {
  return `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function relTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return formatDay(iso);
}
